'use strict';

import {reverseUrl} from 'utils/django';

import './style.css';
import modalDirective from '../../rest-modal';
import template from './template.html';


export default modalDirective({
	template: template,
	resolve: {
		users: resolveActiveUsersForIncident,
	},
	controller: controller,
	refreshIncident: true,
});


function controller($scope) {
	'ngInject';

	$scope.selectedUsers = [];

	$scope.toggleUser = function(user) {
		var removed = false;
		for (var i = 0; i < $scope.selectedUsers.length; i++) {
			if ($scope.selectedUsers[i].uuid == user.uuid) {
				user.isSelected = false;
				removed = true;
				$scope.selectedUsers.splice(i--, 1);
			}
		}
		if (!removed) {
			$scope.selectedUsers.push(user);
			user.isSelected = true;
		}
		$scope.formattedUsers = $scope.selectedUsers.map(u => ({
			uuid: u.uuid,
			phone_number: u.phone_number,
		}))
		$scope.maxRounds = Math.ceil(2.1*$scope.selectedUsers.length);
	}
}


function resolveActiveUsersForIncident($incident, $http, $context) {
	'ngInject';

	var url = reverseUrl('entities:entity');
	return $http.get(url).then(function(response) {
		var users = [];
		var teamUUIDs = $incident.team.map(function(incidentUser) {
			return incidentUser.user.uuid;
		});
		for (let role of response.data.roles) {
			if ($context.roles.indexOf(role.display_name) == -1) {
				continue;
			}
			for (let user of role.users) {
				if (!user.is_active || !user.is_available) {
					continue;
				}
				if (teamUUIDs.indexOf(user.uuid) == -1) {
					user.role = role.display_name;
					users.push(user);
				}
			}
		}
		const sortedUsers = [...users].sort((l, r) => {
			if (l.last_name > r.last_name) { return 1; }
			if (l.last_name < r.last_name) { return -1; }
			if (l.first_name > r.first_name) { return 1; }
			if (l.first_name < r.first_name) { return -1; }
			return 0;
		});
		return sortedUsers;
	});
}
